import { useContext } from 'react';
import './EventList.css';
import {
    ViewEvent, EventContext, SystemPreferences, darkModePallete
} from "../../../Admin/AdminImports";


export const EventItem = ({ event }) => {
    const { adminView } = useContext(SystemPreferences)
    return (
        <div className="EventItem-Container"
            data-testid={`event-items-${event.id}`}
            
        >
            <div className={`EventItem-Date`} style={adminView.viewMode ? { color: "#bfbfbf" } : {}}>
                {event.date}
            </div>

            <div className={`EventItems`}>
                <div className="EventItem-Time" style={adminView.viewMode ? { color: "#bfbfbf" } : {}}>
                    {event.startTime} <span className="EventItem-Duration">{(event.endTime)}</span>
                </div>
                <div className={`EventItem-Divider`}></div>
                <div className="EventItem-Details">
                    <div className="EventItem-Title" style={adminView.viewMode ? darkModePallete.textColor : {}} data-testid={`event-title-${event.id}`}>{event.title}</div>
                    <a href={event.link} style={adminView.viewMode ? { color: "#bfbfbf" } : {}} className="EventItem-Link">{event.location}</a>
                </div>
            </div>
        </div>
    );
};



export const EventList = () => {
    const { adminView } = useContext(SystemPreferences)
    const { events, selectedEvent, handleViewEvent, handleCloseEvent } = useContext(EventContext);

    return (
        <div className="EventList" style={adminView.viewMode ? darkModePallete.secondaryBackground : {}}>
            {events.map(eventItem => (
                <div
                    key={eventItem.id}
                    onClick={() => handleViewEvent(eventItem)} >
                    <EventItem event={eventItem} />
                </div>
            ))}
            {selectedEvent && <ViewEvent event={selectedEvent} onClose={handleCloseEvent} />}
        </div>
    );
};
